var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavehand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 93,
    viewBox: "0 0 90 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8816 42.2111L45.9158 21.4102C46.6602 20.3068 47.7593 19.5085 48.9711 19.1908C50.183 18.8731 51.4084 19.0621 52.3778 19.7161C53.3472 20.3702 53.9812 21.4357 54.1403 22.6784C54.2994 23.9211 53.9706 25.2391 53.2262 26.3424L41.0632 44.3699",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.228 26.3399L56.9705 20.793C57.3391 20.2467 57.7986 19.7695 58.3229 19.3887C58.8471 19.0079 59.4258 18.7309 60.0258 18.5736C60.6259 18.4163 61.2356 18.3817 61.8201 18.4719C62.4046 18.562 62.9525 18.7751 63.4325 19.0989C63.9125 19.4228 64.3152 19.8511 64.6176 20.3593C64.92 20.8676 65.1162 21.4459 65.195 22.0612C65.2738 22.6765 65.2336 23.3168 65.0767 23.9455C64.9199 24.5741 64.6494 25.1789 64.2808 25.7252L48.3754 49.2996",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5369 31.2696C61.2813 30.1662 62.3804 29.3679 63.5922 29.0502C64.8041 28.7325 66.0295 28.9214 66.9989 29.5755C67.9683 30.2295 68.6023 31.2951 68.7614 32.5378C68.9205 33.7805 68.5917 35.0984 67.8472 36.2018L55.6843 54.2293",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1042 41.7499C64.8486 40.6465 65.9476 39.8482 67.1595 39.5305C68.3714 39.2128 69.5968 39.4017 70.5662 40.0558C71.5356 40.7098 72.1696 41.7754 72.3287 43.0181C72.4878 44.2607 72.159 45.5787 71.4145 46.6821L55.5091 70.2565C52.5314 74.6699 48.1353 77.8632 43.2878 79.134C38.4404 80.4048 33.5387 79.649 29.661 77.0328L24.7875 73.7446L25.2943 74.0866C22.8727 72.4534 20.9506 70.1613 19.7008 67.416C18.4509 64.6707 17.9124 61.5583 18.1335 58.3582C18.1605 57.9734 18.1884 57.5887 18.2173 57.2039C18.3533 55.3624 19.2572 48.2677 20.9284 35.9151C21.0987 34.6559 21.7258 33.4575 22.6764 32.5748C23.6269 31.692 24.8258 31.1946 26.0181 31.1884C27.2885 31.1812 28.4736 31.6226 29.3853 32.4425C30.2969 33.2623 30.8829 34.4136 31.0501 35.7134L31.8814 42.2072",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_24757_216203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.178 36.2617C76.4738 35.687 77.3331 35.8316 77.4246 36.4714V36.4714C77.4654 36.7573 77.6875 36.984 77.9722 37.0319V37.0319C78.6096 37.1391 78.7271 38.0072 78.1511 38.3003V38.3003C77.8944 38.4309 77.745 38.7126 77.7857 38.9977L77.7907 39.0325C77.8816 39.6682 77.1048 40.0477 76.6592 39.5852V39.5852C76.4572 39.3756 76.142 39.3226 75.8826 39.4546V39.4546C75.3102 39.7458 74.7003 39.1331 74.9941 38.5621L75.0102 38.5308C75.142 38.2747 75.0929 37.9597 74.8931 37.7524V37.7524C74.4446 37.2869 74.8397 36.505 75.4771 36.6122V36.6122C75.7618 36.6601 76.0458 36.5185 76.178 36.2617V36.2617Z",
    fill: "#FF6F66"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_24757_216203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0256 66.918C64.3214 66.3433 65.1807 66.4878 65.2722 67.1277V67.1277C65.3131 67.4135 65.5351 67.6403 65.8199 67.6882V67.6882C66.4573 67.7954 66.5748 68.6635 65.9987 68.9566V68.9566C65.7421 69.0872 65.5926 69.3688 65.6334 69.6539L65.6384 69.6887C65.7293 70.3244 64.9524 70.7039 64.5068 70.2415V70.2415C64.3049 70.0319 63.9896 69.9789 63.7302 70.1109V70.1109C63.1579 70.4021 62.5479 69.7893 62.8418 69.2183L62.8579 69.1871C62.9897 68.931 62.9406 68.616 62.7408 68.4086V68.4086C62.2923 67.9432 62.6874 67.1613 63.3247 67.2685V67.2685C63.6095 67.3164 63.8935 67.1747 64.0256 66.918V66.918Z",
    fill: "#FF6F66"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_24757_216203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7125 11.1947C51.3634 10.6507 51.9192 9.97952 52.5187 10.221V10.221C52.7866 10.3289 53.0941 10.2504 53.2782 10.028V10.028C53.6904 9.53019 54.5005 9.86356 54.4655 10.509V10.509C54.4499 10.7965 54.6187 11.067 54.8858 11.1746L54.9184 11.1877C55.5141 11.4277 55.4532 12.2901 54.8297 12.4439V12.4439C54.5471 12.5136 54.3432 12.7598 54.3274 13.0505V13.0505C54.2926 13.6917 53.4567 13.9125 53.1098 13.372L53.0908 13.3424C52.9353 13.1 52.6381 12.9846 52.3585 13.0536V13.0536C51.731 13.2084 51.2523 12.4747 51.6646 11.9769V11.9769C51.8487 11.7544 51.8685 11.4377 51.7125 11.1947V11.1947Z",
    fill: "#66B5F8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_24757_216203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7005 20.4352C34.1937 19.4701 35.6362 19.7145 35.7888 20.7889V20.7889C35.8569 21.2687 36.2299 21.6501 36.7073 21.731V21.731C37.7765 21.9121 38.0099 23.3532 37.0459 23.8472L36.9953 23.8731C36.5664 24.0929 36.3243 24.5609 36.3921 25.0389L36.4034 25.1181C36.5546 26.1831 35.2534 26.814 34.5094 26.0364V26.0364C34.1706 25.6823 33.6401 25.5925 33.2049 25.8154V25.8154C32.2492 26.3052 31.2246 25.2803 31.7135 24.3236L31.7498 24.2526C31.9692 23.8232 31.8924 23.3012 31.5585 22.9522L31.5191 22.911C30.7686 22.1266 31.4573 20.8417 32.5265 21.0228V21.0228C33.004 21.1037 33.4803 20.8662 33.7005 20.4352V20.4352Z",
    fill: "#FF6F66"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5751 64.5394C70.7272 64.6183 71.6103 65.6208 71.3899 66.7544C70.772 69.9341 69.2507 72.8855 66.9876 75.2436C64.7245 77.6018 61.8381 79.2431 58.6865 79.9913C57.5629 80.2581 56.525 79.417 56.3988 78.2691V78.2691C56.2725 77.1212 57.1088 76.105 58.2207 75.7929C60.3982 75.1817 62.3869 73.9978 63.9702 72.3479C65.5536 70.698 66.6547 68.6624 67.1759 66.4616C67.442 65.3378 68.423 64.4604 69.5751 64.5394V64.5394Z",
    fill: "#FAFEFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3301 68.4191C76.7338 68.5279 77.7994 69.7596 77.5184 71.1392C76.7304 75.0087 74.8437 78.5901 72.0591 81.4401C69.2745 84.2902 65.738 86.2597 61.8879 87.1374C60.5152 87.4504 59.2591 86.4137 59.1177 85.013V85.013C58.9763 83.6122 60.0069 82.3825 61.3657 82.0142C64.0269 81.2928 66.4641 79.8713 68.4123 77.8772C70.3606 75.8831 71.7251 73.4136 72.3844 70.7363C72.7211 69.3693 73.9265 68.3104 75.3301 68.4191V68.4191Z",
    fill: "#FAFEFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_24757_216203",
    x: 70.6992,
    y: 31.8984,
    width: 11.8242,
    height: 11.8906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_24757_216203"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_24757_216203",
    x: 58.5469,
    y: 62.5547,
    width: 11.8242,
    height: 11.8906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_24757_216203"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_24757_216203",
    x: 47.5117,
    y: 5.78906,
    width: 11.8203,
    height: 11.8906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_24757_216203"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_24757_216203",
    x: 27.2031,
    y: 15.8281,
    width: 14.4492,
    height: 14.5547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_24757_216203"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavehand);
export default __webpack_public_path__ + "static/media/wavehand.7aed6d5b6565d70e65cd35311f3caf93.svg";
export { ForwardRef as ReactComponent };